<template>
  <a-modal
      title="裁判员信息"
      :visible="visible"
      width="800px"
      @ok="handleSubmit"
      okText="提交数据报送审核"
      @cancel="handleCancel"
    >
  <div class="organization">
      <a-form :form="form" class="form" @submit="handleSubmit">
        <div style="position: relative;overflow: hidden;">
          <upload ref="upload" style="width: 150px;float: left;" :length="1" :fixedNumber="[5,7]" :imgs="image" @uploadSuccess="uploadSuccess" :cutImg="true" :uploadTest="'一寸照片'"></upload>
          <div style="float: left;width: 600px;">
            <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
              <a-input addon-before="*姓名" placeholder="姓名" v-decorator="['name', { rules: [{required: true, whitespace:true, message: '请输入姓名'}]}]"/>
            </a-form-item>
            <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
              <a-input addon-before="*身份证号" placeholder="请输入证件号码" v-decorator="['card', { rules: [{required: true, whitespace:true, message: '请输入请输入证件号码'}]}]"/>
            </a-form-item>
          </div>
        </div>
        <div>
          
          <a-form-item style="margin-bottom:5px;width: 370px;float: left;z-index: 999;" :wrapperCol="wrapperCol">
            <a-input addon-before="*银行卡号" placeholder="银行卡号" v-decorator="['bankCard', { rules: [{required: true, whitespace:true, message: '请输入银行卡号'}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;width: 370px;float: left;z-index: 999;margin-left: 10px;" :wrapperCol="wrapperCol">
            <a-input addon-before="*开户行（具体到支行）" placeholder="开户行" v-decorator="['openingBank', { rules: [{required: true, whitespace:true, message: '请输入开户行'}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;width: 370px;float: left;z-index: 999;" :wrapperCol="wrapperCol">
            <a-input addon-before="*紧急联系人" placeholder="紧急联系人" v-decorator="['contact', { rules: [{required: true, whitespace:true, message: '请输入紧急联系人'}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;width: 370px;float: left;z-index: 999;margin-left: 10px;" :wrapperCol="wrapperCol">
            <a-input addon-before="*紧急联系人电话" placeholder="紧急联系人电话" v-decorator="['contactMobile', { rules: [{required: true, whitespace:true, message: '请输入紧急联系人电话'}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">竞技裁判等级</span>
            <a-select placeholder="选择裁判等级" 
              v-decorator="[
                'sportsLevel',
              ]"
            style="width: 262px" :allowClear="true">
            <a-select-option value="">无等级</a-select-option>
              <a-select-option value="国际级">国际级</a-select-option>
              <a-select-option value="预备国家级">预备国家级</a-select-option>
              <a-select-option value="国家级">国家级</a-select-option>
              <a-select-option value="一级裁判员">一级裁判员</a-select-option>
              <a-select-option value="二级裁判">二级裁判</a-select-option>
              <a-select-option value="三级裁判员">三级裁判员</a-select-option>
            </a-select>
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;margin-left: 10px;">品势裁判等级</span>
            <a-select placeholder="选择裁判等级" 
              v-decorator="[
                'poomsaeLevel',
              ]"
            style="width: 262px" :allowClear="true">
              <a-select-option value="">无等级</a-select-option>
              <a-select-option value="国际级">国际级</a-select-option>
              <a-select-option value="预备国家级">预备国家级</a-select-option>
              <a-select-option value="国家级">国家级</a-select-option>
              <a-select-option value="一级裁判员">一级裁判员</a-select-option>
              <a-select-option value="二级裁判">二级裁判</a-select-option>
              <a-select-option value="三级裁判员">三级裁判员</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">代表单位</span>
            <a-select placeholder="选择代表单位" 
              v-decorator="[
                'companyCode',
              ]"
            style="width: 290px" :allowClear="true">
              <a-select-option v-for="(item,index) in areaList" :key="index" :value="item.provinceCode + ''">{{ item.areaName }}</a-select-option>
              
            </a-select>
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;margin-left: 10px;">西裤尺寸</span>
            <a-select placeholder="选择西裤尺寸" 
              v-decorator="[
                'western',
              ]"
            style="width: 290px" :allowClear="true">
              <a-select-option value="28">28</a-select-option>
              <a-select-option value="29">29</a-select-option>
              <a-select-option value="30">30</a-select-option>
              <a-select-option value="31">31</a-select-option>
              <a-select-option value="32">32</a-select-option>
              <a-select-option value="33">33</a-select-option>
              <a-select-option value="34">34</a-select-option>
              <a-select-option value="35">35</a-select-option>
              <a-select-option value="36">36</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;width: 370px;float: left;z-index: 999;" :wrapperCol="wrapperCol">
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">*衬衫型号</span>
            <a-select placeholder="选择衬衫型号" 
                v-decorator="[
                'shirtModel',
                { rules: [{ required: true, message: '选择衬衫型号!' }] },
              ]"
              style="width: 284px" :allowClear="true" >
              <a-select-option value="36">36</a-select-option>
              <a-select-option value="37">37</a-select-option>
              <a-select-option value="38">38</a-select-option>
              <a-select-option value="39">39</a-select-option>
              <a-select-option value="40">40</a-select-option>
              <a-select-option value="41">41</a-select-option>
              <a-select-option value="42">42</a-select-option>
              <a-select-option value="43">43</a-select-option>
              <a-select-option value="44">44</a-select-option>
              <a-select-option value="45">45</a-select-option>
            </a-select>
          </a-form-item>
          
          <a-form-item style="margin-bottom:5px;width: 370px;float: left;z-index: 999;margin-left: 10px;" :wrapperCol="wrapperCol">
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">{{ $t('居住地城市') }}</span>
            <a-cascader style="width:276px;" :options="address" :placeholder="$t('请选择地区')" v-decorator="['regionCode', {rules: [{ required: true, message: $t('请选择地区')}],initialValue: ['500000','500100','500191']}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;width: 370px;float: left;z-index: 999;" :wrapperCol="wrapperCol">
            <a-input addon-before="*联系电话" placeholder="联系电话" v-decorator="['mobile', { rules: [{required: true, whitespace:true, message: '请输入联系电话'}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;width: 370px;float: left;z-index: 999;margin-left: 10px;" :wrapperCol="wrapperCol">
            <a-input :addon-before="$t('详细地址')" :placeholder="$t('请输入详细地址')" v-decorator="['address', { rules: [{required: true, message: $t('请输入详细地址')}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;width: 370px;float: left;z-index: 999;" :wrapperCol="wrapperCol">
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">*鞋码（运动鞋）</span>
            <a-select placeholder="选择鞋码（运动鞋）" 
                v-decorator="[
                'shoeSize',
                { rules: [{ required: true, message: '选择鞋码（运动鞋）!' }] },
              ]"
              style="width: 242px" :allowClear="true" >
              <a-select-option value="36">36</a-select-option>
              <a-select-option value="37">37</a-select-option>
              <a-select-option value="38">38</a-select-option>
              <a-select-option value="39">39</a-select-option>
              <a-select-option value="40">40</a-select-option>
              <a-select-option value="41">41</a-select-option>
              <a-select-option value="42">42</a-select-option>
              <a-select-option value="43">43</a-select-option>
              <a-select-option value="44">44</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;width: 370px;float: left;z-index: 999;margin-left: 10px;" :wrapperCol="wrapperCol">
            <a-input :addon-before="$t('工作单位')" :placeholder="$t('请输入工作单位')" v-decorator="['workUnit', { rules: [{required: true, message: $t('请输入工作单位')}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;width: 370px;float: left;z-index: 999;" :wrapperCol="wrapperCol">
            <a-input :addon-before="$t('职称/职务')" :placeholder="$t('请输入职称/职务')" v-decorator="['duties', { rules: [{required: true, message: $t('请输入职称/职务')}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <a-textarea
              v-model="valData.execution"
              placeholder="请输入执裁经历"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <div v-for="(item,index) in uploadImgList" :key="index" style="width: 150px;float: left;text-align: center;">
              <a-upload
                name="file"
                :action="imgurl"
                listType="text"
                :showUploadList="false"
                @change="handleChangeImage($event, item.value)"
              >
                <div>
                  <img v-if="valData[item.value]" :src="valData[item.value]" style="width:32px;height:32px;">
                  <img v-else src="@comm/assets/img.png">
                  <div class="ant-upload-text">*{{ item.name }}</div>
                </div>
              </a-upload>
            </div>
          </a-form-item>
        </div>
      </a-form>
    
  </div>
</a-modal>
</template>

<script>
import store from '@/store'
import address from '@comm/config/address'
import Upload from '@comm/upload/Upload'
import matchFun from '@comm/utils/matchFun'
import {checkIdCard, getBirthday, getSex} from '@comm/utils/IdCardUtils'
import { getAddressFullCodeByCode } from '@comm/utils/addressUtil'
import { mapState } from 'vuex'
import config from '@comm/http/config'
export default {
  name: 'EditReferee',
  components: {
    Upload
  },
  data () {
    return {
      imgurl: config.baseImgURL,
      matchFun: matchFun,
      visible: false,
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      data: null,
      image: [],
      address: address,
      matchInfo: store.getters['match/matchInfo'],
      matchId: Number(this.$route.query.matchId),
      areaList: [],
      valData: {
        id: null,
        execution: '',
        certificate: null,
        levelImg: null
      },
      uploadImgList: [{
        name: '工作证',
        value: 'certificate'
      }, {
        name: '等级证书',
        value: 'levelImg'
      }],
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  mounted () {
  },
  methods: {
    show(item){
      if (item !== null) {
        this.image = [this.matchFun.randomNumFile('image.jpg', item.image)]
        this.valData = {
          id: item.id,
          execution: item.execution,
          certificate: item.certificate,
          levelImg: item.levelImg
        }
        setTimeout(() => {
          this.form.setFieldsValue({
            name: item.name,
            card: item.card,
            mobile: item.mobile,
            regionCode: getAddressFullCodeByCode(item.areaCode + ''),
            sportsLevel: item.sportsLevel,
            poomsaeLevel: item.poomsaeLevel,
            bankCard: item.bankCard,
            openingBank: item.openingBank,
            shirtModel: item.shirtModel,
            address: item.address,
            contact: item.contact,
            companyCode: item.companyCode,
            workUnit: item.workUnit,
            duties: item.duties,
            western: item.western,
            shoeSize: item.shoeSize,
            contactMobile: item.contactMobile,
          })
        })
      
        // console.log(this.valData,  111)
      } else {
        this.image = []
        this.valData = {
          id: null,
          execution: undefined,
          certificate: null,
          levelImg: null
        }
        setTimeout(() => {
          this.form.setFieldsValue({
            name: '',
            card: ''
          })
        })
      }
      this.findAreaList()
      this.visible = true
    },
    findAreaList () {
      this.$api.match.provinceList().then(res => {
        if (res.status === 0) {
          this.areaList = res.data
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取列表失败')
      })
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // 去掉名称中的空格
          values.name = values.name.replace(/\s/g, '')
          values.card = values.card.replace(/\s/g, '')
          if (!matchFun.phoneFun(values.mobile)) {
            this.$message.error('手机号码不正确')
            return
          }
          if (this.image.length === 0) {
            this.$message.error('请上传寸件照')
            return
          }
          values.image = this.image[0].url
          values = Object.assign({}, values, this.valData)
          values.provinceCode = values.regionCode[0]
          values.cityCode = values.regionCode[1]
          values.areaCode = values.regionCode[2]
          values.matchId = this.matchId
          if (values.card && checkIdCard(values.card)) {
            values.birthday = getBirthday(values.card)
            values.sex = getSex(values.card)
          } else {
            this.$message.error('身份证号码不正确')
            return
          }
          if (!values.sportsLevel && !values.poomsaeLevel) {
            this.$message.error('请至少选择一种裁判等级')
            return
          }
          this.register(values)
        }
      })
    },
    register (valData) {
      console.log(valData)
      this.$api.match.refereeSave(valData).then(res => {
        if (res.status === 0) {
          this.$message.success('成功')
          this.handleCancel()
          this.$emit('ok', 0)
        } else {
          this.$message.warn(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    uploadSuccess (e) {
      this.image = e
    },
    handleChangeImage (info, item) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (fileList[0].response) {
        this.valData[item] = fileList[0].response.data.url
        console.log(this.valData)
        this.$forceUpdate()
      }
    },
    validityDateChange (date, dateString) { // 日期选择器
      this.valData.validityDate = dateString
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.organization{
  .title{
    color: #000;
    line-height: 50px;
    font-size: 16px;
    position: relative;
    .add-right-warp{
      position: absolute;
      right: 0;
      top: 0;
    }
    .add-right{
      display: inline-block;
      cursor: pointer;
      color: #000;
      border-radius: 2px;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      padding: 0 10px;
      border: 1px solid #e8e8e8;
    }
  }
  .list{
    .col{
      margin-bottom: 30px;
      float: left;
      width: 50%;
      &:nth-child(odd){
        .warp{
          margin-left: 3%;
        }
      }
    }
    .warp{
      width: 97%;
      height: 120px;
      border:1px solid #e8e8e8;
      border-radius: 2px;
      display: flex;
      flex-direction: row;
      position: relative;
      background-color:#fff;
      box-shadow: rgba(196, 196, 196, 0.5) 1px 1px 3px 1px;
      &:hover{
        cursor: pointer;
        background-color: #f7f7f7;
      }
      .or-img{
        width: 110px;
        height: 110px;
        border-radius: 50%;
        margin-top: auto;
        margin-bottom: auto;
        padding: 10px;
      }
      .content{
        height: 100%;
        display: flex;
        flex-direction: column;
        div{
          flex: 1;
          color: #000;
          line-height: 40px;
          margin-bottom: 0;
          .or-title{
            color: #999;
          }
        }
      }
      .check{
        position: absolute;
        right: 0;
        color: #fff;
        width: 80px;
        font-size: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background-color: #e8e8e8;
      }
    }
    .active{
      .check{
        background-color: red;
      }
    }
  }
}
.organization /deep/ .ant-select-selection{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
.organization /deep/ .ant-cascader-input{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
.organization /deep/ .ant-calendar-picker-input{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/match/referee/modal/EditReferee.vue